import GET_FEATURE_FLAG from "./graphql/GetFlagOrganization.v4.b2b.graphql";
import {
  GetFlagOrganization,
  GetFlagOrganizationVariables,
} from "./graphql/types/GetFlagOrganization";
import { useQuery } from "@apollo/client";
import { useMe } from "@crehana/web";

type useFlagOrganizationProps = {
  flag: string;
};

const useFlagOrganization = ({ flag }: useFlagOrganizationProps) => {
  const { me } = useMe();
  const { data, loading } = useQuery<
    GetFlagOrganization,
    GetFlagOrganizationVariables
  >(GET_FEATURE_FLAG, {
    variables: { slug: me?.organization?.slug },
    context: { clientName: "v4.b2b" },
    fetchPolicy: "network-only",
  });

  const currentFlag = data?.b2bOrganizationCurrent?.features?.find(
    (feature) => feature?.slug === flag
  );

  return {
    isActive: currentFlag?.isActive || false,
    isLoading: loading,
  };
};

export default useFlagOrganization;
